<template lang="html">
    <div class="services component-services">
        <div class="service" v-for="service in services" v-if="isDisaplay(service)">
            <div class="list" v-if="service.type == 'select'">
                <z-select
                    v-on:change="changeService"
                    v-model="service.value"
                    v-bind:label="service.name"    
                    v-bind:name="('service-' + service.id)"
                    v-bind:id="('service-' + service.id)"
                    v-bind:readonly="$props.readonly"
                    v-bind:disabled="$props.disabled"
                >
                    <option
                        v-for="value in service.values"
                        v-bind:key="('service-' + service.id + '-value-' + value.id)"
                        v-bind:value="parseInt(value.id)"
                    >{{value.name}}</option>
                </z-select>
            </div>

            <radio v-if="service.type == 'radio'" v-on:change="changeService">
                <div class="md-caption">{{ service.name }}</div>
                <md-radio
                    v-for="value in service.values"
                    v-model="service.value"
                    v-bind:value="parseInt(value.id)"
                    v-bind:key="value.id"
                    v-bind:readonly="$props.readonly"
                    v-bind:disabled="$props.disabled"
                >{{ value.name }}</md-radio>
            </radio>

            <div class="checkbox" v-if="service.type == 'checkbox'" v-bind:class="{'z-check-container': (service.values.length > 1)}">
                <div class="md-caption" v-if="service.values.length > 1">{{ service.name }}</div>
                <z-check
                    v-for="value in service.values"
                    v-model="service.value"
                    v-on:change="changeService"
                    v-bind:label="value.name"
                    v-bind:id="('service-' + service.id + '-' + value.id)"
                    v-bind:key="('service-' + service.id + '-' + value.id)"
                    v-bind:value="parseInt(value.id)"
                    v-bind:disabled="$props.disabled"
                />
            </div>
        </div>
    </div>
</template>
<script>
import ZCheck from '@/components/ZCheck';
import ZSelect from '@/components/ZSelect';
export default {
    props: {
        section: {
            type: String,
            default: null
        },
        form: {
            type: String,
            default: null
        },
        freight: {
            type: Object,
            default: () => {}
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    components: {ZCheck, ZSelect},
    name: 'services',
    data() {
        return {
            services: [],
            current_freight_id: null
        }
    },
    created() {
        this.$store.dispatch('cost/getAdditionalServices', { order_by: 'sort', order_type: 'asc', filter: { section: this.section }}).then(services => {
            this.services = services;
        });
        if (this.$props.freight.id) this.current_freight_id = this.$props.freight.id;
    },
    methods: {
        async saveValues(id = null) {
            return new Promise(async resolve => {
                let notUpdatePrice = this.freight.not_update_price;
                if (id) {
                    this.current_freight_id = id;
                    notUpdatePrice = true;
                }
                
                if (!this.freight || !this.freight.id) return;
                let servicesToAttach = [], attachedServices = [], servicesToDetach = [], freightServices = this.freight.services;
                if (!freightServices) freightServices = [];

                //id услуг, которые нужно прикрепить
                this.services.filter(service => this.isDisaplay(service)).forEach(service => {
                    switch(service.type) {
                        case 'select':
                            if (service.value) servicesToAttach.push(parseInt(service.value));
                            break;
                        case 'radio':
                            if (service.value) servicesToAttach.push(parseInt(service.value));
                            break;
                        case 'checkbox':
                            if (service.value && service.value.length) service.value.forEach(value => servicesToAttach.push(parseInt(value)));
                            break;
                    }
                });

                //id услуг, которые нужно открепить
                if (freightServices && Object.keys(freightServices).length) freightServices.forEach(service => {
                    if (servicesToAttach.indexOf(service.id) == -1 && service.service.section == this.section) servicesToDetach.push(service.id);
                });

                //прикрепляем услуги
                if (servicesToAttach && servicesToAttach.length)
                    await this.$store.dispatch('deals/attachFreightService', {
                        section: this.section,
                        freight_id: this.current_freight_id,
                        service_values: servicesToAttach,
                        not_update_price: notUpdatePrice,
                    });
                
                if (servicesToDetach && servicesToDetach.length)
                    await this.$store.dispatch('deals/detachFreightService', {
                        section: this.section,
                        freight_id: this.current_freight_id,
                        service_values: servicesToDetach,
                        not_update_price: notUpdatePrice
                    });

                this.$root.$off('save-services-' + this.current_freight_id + '-' + this.section);

                resolve(true);
            });
        },
        updateServiceValues() {
            if (!this.services || !this.freight) return;
            //т.к. одновременно может существовать несколько компонентов, то событие должно иметь уникальное имя.
            //следовательно, обработчик создаётся после того, как был получен груз. т.к. обновление this.freight и this.services может произойти несколько раз,
            //то нужно каждый раз удалять слушатель события
            this.$root.$off('save-services-' + this.freight.id + '-' + this.section);
            this.$root.$on('save-services-'  + this.freight.id + '-' + this.section, () => this.saveValues());
            this.$on('save', () => this.saveValues());

            this.services.forEach(service => {
                switch(service.type) {
                    case 'select':   this.$set(service, 'value', null); break;
                    case 'radio':    this.$set(service, 'value', null); break;
                    case 'checkbox': this.$set(service, 'value', []);   break;
                }
                if (typeof this.freight.services != 'undefined') {
                    this.freight.services.forEach(freightService => {
                        service.values.forEach(value => {
                            if (parseInt(freightService.pivot.service_value_id) === parseInt(value.id)) {
                                switch(service.type) {
                                    case 'select': service.value = parseInt(value.id); break;
                                    case 'radio':  service.value = parseInt(value.id); break;
                                    case 'checkbox': if (service.value.indexOf(parseInt(value.id)) == -1) service.value.push(parseInt(value.id)); break;
                                }
                            }
                        });
                    });
                }
            });
        },
        changeService() {
            this.$emit('change', this.services);
        },
        isDisaplay(service) {
            if (!service || !service.active) return false;
            if (this.$props.section && service.section != this.$props.section) return false;
            if (
                this.$props.form && service.forms_display &&
                Array.isArray(service.forms_display) &&
                service.forms_display.indexOf(this.$props.form) == -1
            ) return false;

            return true;
        }
    },
    watch: {
        '$props.freight': {
            deep: true,
            handler(freight) {
                if (parseInt(this.current_freight_id) != parseInt(freight.id)) {
                    this.current_freight_id = freight.id;
                    this.updateServiceValues();
                }
            }
        },
        'services'() {
            this.updateServiceValues();
        }
    }
}
</script>
<style lang="sass">
    .component-services
        .radio
            padding: 10px 0
        .list
            display: flex
            align-items: center
            justify-content: flex-start
            .md-field
                margin: 0px 0px 0px 0px !important
                padding-top: 0px
                min-height: 32px
            label
                top: 10px
            .left-label
                flex-shrink: 0
                margin-right: 10px
</style>



// WEBPACK FOOTER //
// Services.vue?3adaa56d